import React, {useState, useRef, useEffect} from "react";
import {Button, Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Pagination from "../../components/common/Pagination";
import {delTopics, getUserTOPListAll} from "../../api/apiClient";
import TableTopBar from "../../components/tables/top/TableTopBar";
import PopUp from "../../components/popUp/PopUp";
import MQTTAcntReg from "../../pages/subPages/MQTTAcntReg";
import MqttTopicReg from "../../pages/subPages/MqttTopicReg";
import Swal from "sweetalert2";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import useAuth from "../../hook/useAuth";
import usePdf from "../../hook/usePdf";

const TableTopic = ({
                      currentPage,
                      setCurrentPage,
                      listPageSize,
                      setListPageSize,
                      total,
                      tableList,
                      updateList,
                      getFullData = null,
                      setIsSearch,
                      searchParam,
                      setSearchParam,
                      setTableList,
                      setTotal
                    }) => {

  /*const [auth, setAuth] = useState("0");

  useEffect(() => {
    setAuth(sessionStorage.getItem("CURRENT_AUTH"));
  }, []);*/

  const auth = useAuth();

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "토픽_.xls")
  }
  const getAllList = () => {
    setIsExport(true);

    getUserTOPListAll(
        currentPage, listPageSize,
        searchParam.searchMqttId,
        searchParam.searchPrpos,
        searchParam.searchSe)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);

      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '토픽.pdf');
      }
      setIsExport(false);

      updateList();
    });
  };

  // 체크박스
  // 체크된 아이템을 담을 배열
  const [checkItems, setCheckItems] = useState([]);

  // 체크박스 단일 선택
  const handleSingleCheck = (checked, id) => {
    if (checked) {
      // 단일 선택 시 체크된 아이템을 배열에 추가
      setCheckItems(prev => [...prev, id]);
    } else {
      // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
      setCheckItems(checkItems.filter((el) => el !== id));
    }
  }

  // 체크박스 전체 선택
  const handleAllCheck = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = [];
      // data.forEach((el) => idArray.push(el.id));
      tableList.forEach((el) => idArray.push(el.mqtt_id));
      setCheckItems(idArray);
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckItems([]);
    }
  }

  // 일괄 삭제
  const delItem = (e) => {
    /* if (checkItems.length < 1) {
       Swal.fire("항목을 선택하세요.");
       return;
     }*/
    const deleteId = e.target.dataset.id;

    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `선택한 id(${deleteId}) 항목을 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delTopics(deleteId).then(res => {
          if (res.data.status === 200) {
            Swal.fire(
                '삭제되었습니다!',
                '',
                'success'
            );
            // setCheckItems([]);
            setIsSearch(true);
            updateList();
          }
        }).catch(err => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
      }
    })
  };

  const regItem = (e = null) => {
    const auth = sessionStorage.getItem('CURRENT_AUTH');
    if (auth != 2) {
      Swal.fire('권한이 없습니다.');
    } else {
      setPopupReg({
        isVisible: true,
        mqtt_id: e.target.dataset.id
      });
    }
  };

  /* 팝업을 위한 state */
  const [openPopupReg, setPopupReg] = useState({isVisible: false, mqtt_id: 0});
  const [openPopupDetail, setPopupDetail] = useState({isVisible: false, mqtt_id: 0, se: null, prpos: '', se_nm: null});

  const closePopupReg = () => {
    setPopupReg({isVisible: false, user_id: 0});
    setIsSearch(true);
    updateList();
  };

  const closePopupDetail = () => {
    setPopupDetail({isVisible: false, user_id: 0});
    setIsSearch(true);
    updateList();
  };

  const handleOpenPopupDetail = (e = null) => {
    setPopupDetail({
      isVisible: true,
      mqtt_id: e.target.dataset.id,
      se: e.target.dataset.se,
      prpos: e.target.dataset.prpos,
      se_nm: e.target.dataset.se_nm,
    });
  };

  return (
      <>
        <PopUp
            // propTitle={'MQTT 인증정보 등록'}
            propTitle={openPopupReg.mqtt_id ? `MQTT 인증정보 수정` : `MQTT 인증정보 등록`}
            propShow={openPopupReg.isVisible}
            setShow={closePopupReg}
        >
          <MQTTAcntReg
              setShow={closePopupReg}
              propAccInfo={openPopupReg}
              propSetPopupReg={setPopupReg}
              updateList={updateList}
          />
        </PopUp>

        <PopUp
            propTitle={'Topic 등록'}
            propShow={openPopupDetail.isVisible}
            propSize={'xl'}
            setShow={closePopupDetail}
        >
          <MqttTopicReg
              propInfo={openPopupDetail}
              propMqttId={openPopupDetail.mqtt_id}
              propPrpos={openPopupDetail.prpos}
              propSe={openPopupDetail.se}
              propSeNm={openPopupDetail.se_nm}
              propTableList={tableList}
              setShow={closePopupDetail}
          />
        </PopUp>

        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: getFullData,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '토픽',
                  }),
                }}
                propDelete={{
                  isEnable: false,
                  delFunc: delItem,
                }}
                propReg={{
                  isEnable: auth === "2",
                  regFunc: regItem,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={"col"}>구분</th>
                  <th className={"col"}>MQTT ID</th>
                  <th className={"col"}>용도</th>
                  <th className={"col"}>Read Topic 수</th>
                  <th className={"col"}>Write Topic 수</th>
                  {!isExport && auth === "2" ? <th className={"col"}>Topic 등록</th> : ''}
                  {!isExport && auth === "2" ? <th className={"col"}></th> : ''}
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return <tr key={idx}>
                          <td>{elem.se_nm}</td>
                          <td>{elem.mqtt_id}</td>
                          <td>{elem.prpos}</td>
                          <td>{elem.r_flag}</td>
                          <td>{elem.w_flag}</td>
                          {
                            !isExport && auth === "2" ?
                                (<td>
                                  <Button
                                      type={"button"}
                                      onClick={handleOpenPopupDetail}
                                      className={"btn reg-btn"}
                                      data-id={elem.mqtt_id}
                                      data-se={elem.se}
                                      data-prpos={elem.prpos}
                                      data-se_nm={elem.se_nm}
                                  >
                                    등록
                                  </Button>
                                </td>) : ''
                          }
                          {
                            !isExport && auth === "2" ?
                                (<td>
                                  <Button type={"button"} variant="primary"
                                          onClick={regItem}
                                          data-id={elem.mqtt_id}
                                          data-topic={elem.topic}
                                  >
                                    수정
                                  </Button>
                                  <Button type={"button"} variant="danger"
                                          data-id={elem.mqtt_id}
                                          onClick={delItem}
                                  >
                                    삭제
                                  </Button>
                                </td>) : ''
                          }
                        </tr>;
                      })) :
                      ('')
                }

                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
                propSearchParam={searchParam}
                propSetSearchParam={setSearchParam}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableTopic;
